var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPinTrans(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    fill: "none",
    viewBox: "0 0 14.286 18.017",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    transform: "matrix(1.4761 0 0 1.4761 .63346 .63099)",
    d: "m4.4102.25c-1.0653 0-2.1306.40597-2.9434 1.2188-.73672.73672-1.14 1.681-1.209 2.6445-.050074.78688.09656 1.489.39258 2.1094.42187.88411 1.0504 1.3644 1.8457 1.7695 1.4321.72957 1.9021 2.0747 1.9141 3.1133.011964-1.0385.48196-2.3837 1.9141-3.1133.79529-.40515 1.4238-.88542 1.8457-1.7695.29602-.62035.44265-1.3225.39258-2.1094-.068957-.96356-.47226-1.9078-1.209-2.6445-.8128-.81278-1.8781-1.2188-2.9434-1.2188zm0 2.3164c1.0198 0 1.8457.82601 1.8457 1.8457 0 1.0198-.82591 1.8477-1.8457 1.8477-1.0198 0-1.8457-.82786-1.8457-1.8477 0-1.0197.82591-1.8457 1.8457-1.8457z",
    clipPath: "url(#clipPath10831)",
    fill: "#b3b3b3",
    opacity: 0.33,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.355,
    style: {
      paintOrder: "stroke markers fill"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10831"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect1",
    x: -0.99728,
    y: -1.2538,
    width: 10.817,
    height: 13.057,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinTrans);
export default __webpack_public_path__ + "static/media/icon_pin_trans.e17a81511d5bdb326c5ebf585b6796a3.svg";
export { ForwardRef as ReactComponent };